import React, { useRef, useState, useEffect, Fragment, createRef } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import * as transactionListActions from './actions';

import { useDrizzleContext } from "../drizzle/drizzleContext";

import PropTypes from 'prop-types'
import classnames from 'classnames';
import { List, WindowScroller, AutoSizer } from 'react-virtualized'
import Will from './Will';
import Checkbox from '../components/Checkbox';
import Tooltip from '../components/Tooltip'

const WillList = ({
  dispatch,
  accounts,
  transactions,
  transactionStack,
  style,
  wills,
  owner,
  onClickForManipulation
}) => {
  const pathname = useLocation().pathname;
  const drizzle = useDrizzleContext();
  const contract = drizzle.contracts.TkgGoldBuyingAndSelling;

  const listRef = useRef(null);
  const inputRef = createRef(null);
  const [ sortedWills, setSortedWills ] = useState(wills);
  const [ order, setOrder ] = useState({
    userAddr: "ASCEND",
    amount: "ASCEND",
    priceForToken: "ASCEND",
    indicatedTime: "ASCEND"
  });
  var input = null;

  const filesRefs = {}

  useEffect(() => {
    if (wills.length > 0)
      setSortedWills(wills);
  }, [wills]);

  useEffect(() => {
    input = inputRef.current;
  }, [pathname]);

  const emptyRowsRenderer = () => {
    return (
      <div className='pv3 tc gray f5'>
        There are no available intents to sell.
      </div>
    )
  }

  const rowRenderer = ({ index, key, style }) => {
    return (
      <div key={key} style={style} ref={r => { filesRefs[sortedWills[index].transactionId] = r }}>
        <Will
          index={index}
          {...sortedWills[index]}
          owner={owner}
          onClickForManipulation={onClickForManipulation}
        />
      </div>
    )
  }

  const onClickSort = key => {
    var res = wills.slice(0, wills.length);

    if (order[key] === "DESCEND") {
      res.sort((a, b) => parseInt(b[key]) - parseInt(a[key]))
      setOrder({ userAddr: "ASCEND", amount: "ASCEND", priceForToken: "ASCEND", indicatedTime: "ASCEND", [key]: "ASCEND"} );
    } else {
      res.sort((a, b) => parseInt(a[key]) - parseInt(b[key]))
      setOrder({ userAddr: "ASCEND", amount: "ASCEND", priceForToken: "ASCEND", indicatedTime: "ASCEND", [key]: "DESCEND"} );
    }
    setSortedWills(res);
  }

  const rowCount = sortedWills.length

  return (
    <section ref={(el) => { const root = el }} className='relative' style={style}>
      <Fragment>
        <div className='flex items-center pv2 gray'>
          <button className='flex-grow-1 w-30' onClick={() => onClickSort("userAddr")} aria-label={ ('sortBy', 'terms.userAddr') } >
            <div className='f5 tc truncate charcoal'>User Address</div>
          </button>
          <button className='flex-grow-1 w-20' onClick={() => onClickSort("amount")} aria-label={ ('sortBy', 'terms.Amount') }>
            <div className='f5 tc truncate charcoal'>Amount</div>
          </button>
          <button className='flex-grow-1 w-20' onClick={() => onClickSort("priceForToken")} aria-label={ ('sortBy', 'terms.priceForToken') } >
            <div className='f5 tc truncate charcoal'>Price</div>
          </button>
          <button className='flex-grow-1 w-20' onClick={() => onClickSort("indicatedTime")} aria-label={ ('sortBy', 'terms.indicatedDate') } >
            <div className='f5 tc truncate charcoal'>Time to Indicate</div>
          </button>
        </div>
        <WindowScroller>
          {({ height, isScrolling, onChildScroll, scrollTop }) => (
            <div className='flex-auto' style={{ background: 'white' }}>
              <AutoSizer disableHeight>
                {({ width }) => (
                  <List
                    ref={listRef}
                    autoHeight
                    width={width}
                    height={height}
                    className='outline-0'
                    aria-label={'sortedWillsListLabel'}
                    rowCount={rowCount}
                    rowHeight={36}
                    noRowsRenderer={emptyRowsRenderer}
                    rowRenderer={rowRenderer}
                    isScrolling={isScrolling}
                    onScroll={onChildScroll}
                    scrollTop={scrollTop}
                    data={sortedWills}
                  />
                )}
              </AutoSizer>
            </div>
          )}
        </WindowScroller>
      </Fragment>
    </section>
  )
}

const mapStateToProps = state => {
  return {
    accounts: state.accounts,
    contracts: state.contracts,
    transactions: state.transactions,
    transactionStack: state.transactionStack
  };
};

export default connect(mapStateToProps)(WillList);
